module.exports = (__webpack_require__(17))(40);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/defineProperty.js from dll-reference vendor
// module id = 811
// module chunks = 0